<template>
    <div class="wrapper-outer">
        <div class="image__wrapper">
            <div class="image-dots-wrapper"></div>
        </div>
        <div class="wrapper">
            <div class="tile__wrapper">
                <div class="tile">
                    <h1 class="heading">Prague</h1>
                    <p class="paragraph-main-medium">
                        A popular tourist destination and a great place to live; Prague is probably best known for its
                        baroque architecture and cobble stone streets, the many museums, galleries, and artistic
                        performances, and of course the great Czech beer - which is served in a wealth of local
                        restaurants and pubs. Plus, nearly everything is within walking distance, making it both an
                        ideal city to explore and very convenient for daily life.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "PragueBanner"
  };
</script>

<style scoped lang="scss">
    @import "../../assets/scss/globals";
    @import "~@bistudio/bohemia-vue-components/dist/scss/colors";
    @import "~@bistudio/bohemia-vue-components/dist/scss/sizes";
    @import "~@bistudio/bohemia-vue-components/dist/scss/fonts";
    @import "~@bistudio/bohemia-vue-components/dist/scss/breakpoints";

    $bg-color: #ffffff;
    $dot-color: $dusty-gray;
    $header-overlap: 1700px;

    // Dimensions
    $dot-size: 2px;
    $dot-space: 1px;

    .heading {
        text-transform: none;
        color: white;
        font-size: 66px;
        @media (max-width: $tablet) {
            font-size: 36px;
        }
    }

    .paragraph-main-medium, .heading-53 {
        color: white;
        margin-top: 38px;
    }

    .paragraph-main-medium {
        letter-spacing: 0.13px;
        line-height: 40px;

        @media(max-width: $compact) {
            margin-top: 38px;
            letter-spacing: 0.1px;
            line-height: 24px;
        }
    }

    .wrapper-outer {
        position: relative;
        margin-top: 120px;
        margin-bottom: 300px;
        min-height: 600px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        @media (max-width: $tablet) {
            margin-bottom: 800px;
        }

        @media (max-width: 425px) {
            margin-bottom: 250px;
        }
    }

    .wrapper {
        margin: auto;
        width: 100%;
        z-index: 2;
        max-width: $sub-nav-container-width;
        margin-top: -100px;

        @media (max-width: 1024px) {
            padding: 2em;
        }

        @media (max-width: $tablet) {
            padding: 1em;
        }
    }


    .image__wrapper {
        position: absolute;
        top: 0;
        width: 56%;
        height: 125%;
        left: 0;
        z-index: 1;
        background-image: url(/static/img/expat_page/jeshoots-com-267897-unsplash.jpg);
        background-size: 50% 100%;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;

        @media (max-width: $tablet) {
            width: 100%;
            top: 600px;
        }

        @media (max-width: 425px) {
            height: 218px;
            top: 600px;
        }
    }

    .tile__wrapper {
        display: flex;
        align-content: flex-end;
        justify-content: flex-end;
    }

    .tile {
        background-color: $mine-shaft;
        position: relative;
        padding: 76px;
        max-width: 720px;
        min-height: 559px;

        @media (max-width: 1024px) {
            max-width: 100%;
        }

        @media (max-width: 1100px) {
            padding: 40px;
            max-height: 559px;
        }

        @media (max-width: $compact) {
            margin: 9px;
            padding: 40px;
        }

        @media (max-width: 320px) {
            padding: 25px;
        }

        &:before {
            content: '';
            background-image: linear-gradient(270deg, #00ba88 0%, #00b5f2 100%);
            z-index: -5;
            width: 100%;
            height: 100%;
            left: 18px;
            top: 18px;
            position: absolute;
        }
    }

    .image-dots-wrapper {
        position: relative;
        width: 100%;
        height: 60px;
        margin-top: -35px;


        &:before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0px;
            background: radial-gradient($dot-color 20%, rgba(0, 0, 0, 0) 10%), radial-gradient($dot-color 15%, rgba(0, 0, 0, 0) 10%), $bg-color;
            background-position: 10px 10px, 10px 10px;
            -webkit-background-origin: padding-box;
            background-origin: padding-box;
            -webkit-background-clip: border-box;
            background-clip: border-box;
            -webkit-background-size: 4px 4px;
            background-size: 10px 10px;


        }
    }



    .responsive--img {
        width: 100%;
        max-width: 100%;
        height: auto;
    }

</style>


// WEBPACK FOOTER //
// src/components/expatsPageComponents/PragueBanner.vue